import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapDepartmentToApiDepartmentDto = (values: ICreateDepartmentForm): IPostNewDepartment | {} => {
  let dataMapping: IPostNewDepartment;

    dataMapping = {
      description: values.description,
      placeID: +values.placeID !== 0 ? +values.placeID : null,
      modemID: +values.modemID !== 0 ? +values.modemID : null,
      modemPort: values.modemPort !== "" ? values.modemPort : null,
      unID: values.unID,
      sapCode: values.sapCode !== "" ? values.sapCode : null,
      isEmporiki: values.isEmporiki,
      isCiti: values.isCiti
    }
  
  return dataMapping;
}


export const createDepartment = ( {data} : {data: ICreateDepartmentForm }): Promise<string> => {
  const department = mapDepartmentToApiDepartmentDto(data);
  return axiosDefaultApi.post(`/api/Departments/InsertDepartment`, department);
};

type QueryFnType = typeof createDepartment;

type UseCreateDepartmentOptions = {
  data: IPostNewDepartment | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateDepartment = ({ config }: UseCreateDepartmentOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useMutation({
    onError: (error: any) => {
        addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Διεύθυνσης.`, 500);
        console.error('Couldnt create new department', error);
        setIsNotificationVisible(true);
      },
      onSuccess: () => {
        queryClient.invalidateQueries(["getAllDepartments"])
        addNotification(`Η Διεύθυνση Δημιουργήθηκε.`, 200);
        setIsNotificationVisible(true);
      },
    ...config,
    mutationFn: createDepartment,
  })
}